import { render } from "./StepByStep.vue?vue&type=template&id=6d29de72&scoped=true"
import script from "./StepByStep.vue?vue&type=script&lang=js"
export * from "./StepByStep.vue?vue&type=script&lang=js"

import "./StepByStep.vue?vue&type=style&index=0&id=6d29de72&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\comprodonto_site_v4\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d29de72"]])

export default __exports__